// File: TopUniversities.jsx

import "./TopUniversities.css"
import React, { useEffect } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase"; // Adjust the path as needed

const TopUniversities = ({ countryData }) => {
  // Pull from the correct prop and the correct field
  const universities = countryData?.topUniversities || {};
  // useEffect(() => {
  //   console.log("Top Universities component mounted", topUniversities)
  //   saveTopUniversities()
  // }, [])

  // const universities = [
  //   {
  //     name: "The University of Manchester",
  //     logo: "https://cdn-icons-png.flaticon.com/512/2602/2602414.png",
  //     location: "Manchester, United Kingdom",
  //     ielts: "6",
  //     ranking: "34",
  //   },
  //   {
  //     name: "University of Warwick",
  //     logo: "https://cdn-icons-png.flaticon.com/512/5315/5315174.png",
  //     location: "Coventry, United Kingdom",
  //     ielts: "6",
  //     ranking: "69",
  //   },
  //   {
  //     name: "University of St Andrews",
  //     logo: "https://cdn-icons-png.flaticon.com/512/9973/9973495.png",
  //     location: "St. Andrews, United Kingdom",
  //     ielts: "6.5",
  //     ranking: "104",
  //   },
  // ]

//   async function saveTopUniversities() {
//   try {
//     const countryRef = doc(db, "countries", "united-kingdom")
//     // Overwrite or create the topUniversities field
//     await updateDoc(countryRef, { topUniversities: universities })
//     console.log("✅ topUniversities updated successfully.")
//   } catch (err) {
//     console.error("❌ Error saving topUniversities:", err)
//   }
// }

  return (
    <div className="universities-container">
      <h1>Top Universities to Study in {countryData?.name}</h1>

      <div className="universities-grid">
        {universities.map((university, index) => (
          <div className="university-card" key={index}>
            <div className="university-header">
              <div className="university-logo-info">
                <img src={university.logo || "/placeholder.svg"} alt={university.name} className="university-logo" />
                <div className="university-info">
                  <h3 className="university-name">{university.name}</h3>
                  <p className="university-location">{university.location}</p>
                </div>
              </div>
              <button className="favorite-btn">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z"
                    stroke="#ccc"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>

            <div className="university-details">
              <div className="detail-item">
                <div className="detail-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
                      stroke="#666"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path d="M14 2V8H20" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M16 13H8" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M16 17H8" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M10 9H9H8" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <div className="detail-content">
                  <p className="detail-label">Minimum IELTS Required</p>
                  <p className="detail-value">{university.ielts}</p>
                </div>
              </div>

              <div className="detail-item">
                <div className="detail-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M12 15C15.866 15 19 11.866 19 8C19 4.13401 15.866 1 12 1C8.13401 1 5 4.13401 5 8C5 11.866 8.13401 15 12 15Z"
                      stroke="#666"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M8.21 13.89L7 23L12 20L17 23L15.79 13.88"
                      stroke="#666"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div className="detail-content">
                  <p className="detail-label">Ranking</p>
                  <p className="detail-value">{university.ranking}</p>
                </div>
              </div>
            </div>

            <button className="apply-now-btn">Apply Now</button>
          </div>
        ))}
      </div>

      <div className="find-university-container">
        <button className="find-university-btn">
          Find Your Dream University
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 12H19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12 5L19 12L12 19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
    </div>
  )
}

export default TopUniversities
